<template>
  <v-chip
    dark
    tabindex="0"
    class="zoox-component zoox-status"
    :color="color"
    v-on="$listeners"
  >
    <slot></slot>
  </v-chip>
</template>

<script>
/**
 * @displayName Status
 */
export default {
  name: 'ZStatus',
  props: {
    state: {
      type: String,
      required: true,
      validate(value) {
        return /^(good|bad|medium)$/.test(value)
      },
    },
  },
  computed: {
    color() {
      switch (this.state) {
        case 'good':
          return 'var(--lightgreen)'
        case 'bad':
          return 'var(--red)'
        case 'medium':
          return 'var(--orange)'
      }
      return null
    },
  },
}
</script>

<style lang="scss">
.zoox-status {
  height: 24px !important;
  padding: 3px 10px !important;

  span {
    font-size: 0.9375rem;
    font-weight: 400;
  }
}
</style>
